import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

const Accordion = ({ items }) => {
  const defaultTitles = [
    "Property Basic Info", "Address Info", "Apartment Info",
    "Villa Info", "Layout Info", "Basic Info", "Dimension (in feet)",
    "Documents", "More Info", "Media Info", "Property Area & Rate",
    "Property Sourced By Info"
  ];

  const isDefaultOpen = (title) => defaultTitles.includes(title);

  return (
    <div className="w-full space-y-2 relative">
      {items.map((item, index) => (
        <Disclosure key={index} defaultOpen={isDefaultOpen(item.title)}>
          {({ open }) => (
            <div className="border border-gray-200 rounded-lg ">
              <Disclosure.Button className={`flex items-center justify-between w-full p-4 text-left transition-colors ${
                open ? "bg-gray-50" : "bg-white hover:bg-gray-50"
              }`}>
                <span className="text-lg font-medium text-customGreen">
                  {item.title}
                </span>
                <ChevronDownIcon
                  className={`w-5 h-5 text-gray-500 transform transition-transform duration-200 ${
                    open ? "rotate-180" : ""
                  }`}
                />
              </Disclosure.Button>
              
              <Disclosure.Panel className="transition-all duration-300">
                <div className="p-4 bg-white border-t border-gray-200">
                  {item.content}
                </div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      ))}
    </div>
  );
};

export default Accordion;
